import { graphql, type ResultOf } from '@teachino/shared-infrastructure';

export const folderFragment = graphql(`
  fragment Folder on LibraryFolder {
    id
    __typename
    name
    position
    folderColor
    parentFolder {
      id
    }
    parents {
      id
      name
    }
    children {
      id
      name
    }
  }
`);

export type FolderFragment = ResultOf<typeof folderFragment>;

export type Folder = {
  id: string;
  name: string;
  position: number;
  folderColor: string | null;
  parentFolder: {
    id: string;
  } | null;
  parents: {
    id: string;
    name: string;
  }[];
  children: {
    id: string;
    name: string;
  }[];
};

export function convertFolderFragment(fragment: FolderFragment): Folder {
  const { id, name, position, folderColor, parentFolder, parents, children } =
    fragment;
  return {
    id,
    name,
    position,
    folderColor,
    parentFolder,
    parents: parents ?? [],
    children: children ?? [],
  };
}
